// import React, { useState } from "react";
// import styles from "./HrmMain.module.css";
// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
// import { useAuth } from "../../components/context/Auth";
// import HrmDashboard from "./HrmDashboard";
// import Attendance from "./Attendance";
// // ── TABS ────────────────────────────────
// const TABS = [
//   { id: "dashboard", label: "Dashboard" },
//   { id: "attendance", label: "Attendance" },
//   { id: "salarySlip", label: "Salary Slip" },
//   { id: "staff", label: "Staff" },
//   { id: "settings", label: "Settings" },
// ];

// const HrmMain = () => {
//   const { mode } = useAuth();
//   const [activeTab, setActiveTab] = useState("dashboard");

//   return (
//     <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
//       {/* TOP BAR */}
//       <div className={styles.topBar}>
//         <div>
//           <TopTabBar text={`HRM/${activeTab}`} />
//         </div>
//         <div className={styles.mainTab}>
//           <div className={styles.tabBar}>
//             {TABS.map((tab) => (
//               <button
//                 key={tab.id}
//                 className={`${styles.tabBtn} ${activeTab === tab.id ? styles.tabBtnActive : ""}`}
//                 onClick={() => setActiveTab(tab.id)}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* CONTENT */}
//       <>
//         {activeTab === "dashboard" && <HrmDashboard />}
//         {activeTab === "attendance" && <Attendance />}
//       </>
//     </div>
//   );
// };

// export default HrmMain;

import React, { useState } from "react";
import styles from "./HrmMain.module.css";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import { useAuth } from "../../components/context/Auth";
import HrmDashboard from "./HrmDashboard";
import Attendance from "./Attendance";
import SalarySlip from "./SalarySlip";
import HrmSettings from "./HrmSettings";
import Employee from "./Employee";

// ── TABS ────────────────────────────────
const TABS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "attendance", label: "Attendance" },
  { id: "salarySlip", label: "Salary Slip" },
  { id: "employee", label: "Employee" },
  { id: "settings", label: "Settings" },
];

const HrmMain = () => {
  const { mode } = useAuth();
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
      {/* TOP BAR */}
      <div className={styles.topBar}>
        <div>
          <TopTabBar text={`HRM/${activeTab}`} />
        </div>
        <div className={styles.mainTab}>
          <div className={styles.tabBar}>
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`${styles.tabBtn} ${activeTab === tab.id ? styles.tabBtnActive : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <>
        {activeTab === "dashboard" && <HrmDashboard />}
        {activeTab === "attendance" && <Attendance />}
        {activeTab === "salarySlip" && <SalarySlip />}
        {activeTab === "employee" && <Employee />}
        {activeTab === "settings" && <HrmSettings />}
      </>
    </div>
  );
};

export default HrmMain;
